import Footer from './components/FooterLandingPage/Footer.tsx';
import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import Store from './Feature/Store/Store';
import {
    ThemeProvider as LandingThemeProvider,
    CssBaseline,
    Stack,
    Box,
    useMediaQuery
} from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@fontsource/outfit';
import '@fontsource/poppins';
import Navbar from './components/Navbar/Navbar';
import HeroSection from './components/HeroSection/HeroSection';
import OurApproach from './components/OurApproach/OurApproach';
import { theme } from './theme-landing/Theme';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BlogPageMainSection from './components/BlogPageMainSection/BlogPageMainSection';
import BlogDetails from './components/BlogDetails/BlogDetails';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import MoreBlogs from './components/MoreBlogs/MoreBlogs';
import Slideshow from './components/Slideshow/Slideshow';
import About from './components/AboutPage/About';
import Newsletter from './components/Newsletter/Newsletter';
import SignupModal from './components/SignupModal/SignupModal';
import Form from './Feature/Form/Form';
import DreamJobSection from './components/DreamJobSection/DreamJobSection';
import Policies from './components/Policies/Policies';
import Career from './components/Career/Career';
import GetVideoSection from './components/GetVideoSection/GetVideoSection';
import CommunityModal from './components/CommunityModal/CommunityModal.tsx';
import Carousel from './components/Carousel/Carousel';
import FooterCallToAction from './components/FooterLandingPage/FooterCallToAction.tsx';
import './theme-landing/css/cabinet-grotesk.css';
import UpdateSection from './components/UpdateSection/UpdateSection.tsx';
import GettingAJob from './components/GettingAJob/GettingAJob.tsx';
import HowJobfactorWorks from './components/HowJobfactorWorks/HowJobfactorWorks.tsx';
import './App.css'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import AppRouter from './routing/AppRouter';
import { AuthProvider } from './utils/context/AuthContext';
import ThemeProvider from './theme/JobFactorTheme';
import "@fontsource/space-grotesk";

function App() {
    useEffect(() => {
        AOS.init({
            once: true
        });
    }, []);

    const { formik, data, error, isLoading } = Form();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [policy, setPolicy] = useState('term');

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false
            }
        }
    });

    return (
        <Stack>
            <Provider store={Store}>
                    <CssBaseline />
                    <Router>
                        <ThemeProvider>
                            <QueryClientProvider client={queryClient}>
                                <AuthProvider>
                                    <AppRouter />
                                    {/* <div className="global_loader">
                            <Backdrop
                            sx={{ color: '#fff', zIndex: 9999 }}
                            open={true}
                            >
                            <CircularProgress color="inherit" />
                            </Backdrop>
                            </div> */}
                                </AuthProvider>
                            </QueryClientProvider>
                        </ThemeProvider>
                            <LandingThemeProvider theme={theme}>
                        <Routes>
                            <Route
                                path="/"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <HeroSection formik={formik} />
                                        <OurApproach />
                                        <Career />
                                        <UpdateSection formik={formik} />
                                        <GettingAJob />
                                        {/* <Newsletter formik={formik} /> */}
                                        <Carousel />
                                        <DreamJobSection />
                                        <GetVideoSection formik={formik} />
                                        {isMobile ? null : <Slideshow />}
                                        <FooterCallToAction />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            <Route
                                path="/blog"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <BlogPageMainSection formik={formik} />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            <Route
                                path="/blog-details/:id"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <BlogDetails formik={formik} />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            {/* <Route
                                    path=":id/blog-details"
                                    element={<BlogDetails />}
                                ></Route> */}
                            <Route
                                path="/more-blogs"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <MoreBlogs formik={formik} />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            <Route
                                path="/how-jobfactor-works"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <HowJobfactorWorks formik={formik} />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            <Route
                                path="/about"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <About formik={formik} />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                            <Route
                                path="/policy"
                                element={
                                    <>
                                        <ScrollToTop />
                                        <Navbar />
                                        <SignupModal
                                            data={data}
                                            formik={formik}
                                            error={error}
                                            isLoading={isLoading}
                                        />
                                        <Policies
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                        <CommunityModal />

                                        <Footer
                                            policy={policy}
                                            setPolicy={setPolicy}
                                        />
                                    </>
                                }
                            ></Route>
                        </Routes>
                </LandingThemeProvider>
                    </Router>
            </Provider>
        </Stack>
    );
}
export default App;
